import { postJson } from "./fetchService";

/// Collection of all fetch functions regarding the non-company-user management
export const fetchAddress = jsonFetch => coordinates => {
  const route = `/user/location/address`;
  //return "My Awesome Address at " + coordinates.lat + ", " + coordinates.lon;
  return jsonFetch(route, postJson(coordinates));
};
